import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import Button from "@material-ui/core/Button/Button";
import FileManagerDialog from "./FileManagerDialog";
import AddBoxRoundedIcon from '@material-ui/icons/AddBoxRounded';
import {defaultVariabls} from "../../../../config";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Typography from "@material-ui/core/Typography/Typography";
import DescriptionTwoToneIcon from '@material-ui/icons/DescriptionTwoTone';
import SubTitle from "../../../components/elements/SubTitle";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import CancelIcon from '@material-ui/icons/Cancel';
import SubTitleLight from "../../../components/elements/SubTitleLight";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar/Avatar";
import ImageRoundedIcon from "@material-ui/icons/ImageRounded";
import PictureAsPdfRoundedIcon from "@material-ui/icons/PictureAsPdfRounded";
import OndemandVideoRoundedIcon from "@material-ui/icons/OndemandVideoRounded";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import {getComplexFileUrl, truncate} from "../../../../config/values";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import DeleteIcon from "@material-ui/icons/Delete";
import List from "@material-ui/core/List/List";
import Link from "@material-ui/core/Link/Link";

class SingleFileChooser extends React.Component {
    classes = this.props.classes;
    state={

        FileManagerPending: false,
        file: null,
    }
    componentDidMount(){
        this.loadData()
    }
    async loadData(){
        await this.setState({
            file:this.props.initial
        })
        await this.fileChanges();
    }
    toggleOperation= () => {
        this.setState({
            FileManagerPending:!this.state.FileManagerPending,
        })
    }

    setData = async (data) => {
        await this.setState({
            file:data
        })

        await this.fileChanges();
        await this.toggleOperation();
    }
    async removeDataSheet(){
        await this.setState({
            file: null
        });
        this.fileChanges();
    }
    async fileChanges(){
        let {file} = this.state;
        await this.props.onChange(file)
    }
    render(){
        let {FileManagerPending,file} = this.state;
        let{title,required,disabled,print,type,align,label,icon,importer,color} = this.props;
        return(
            <React.Fragment>
                <Grid container spacing={2} direction="row" alignItems="center"  style={{minHeight: importer ? "unset" : 80}} >
                    {
                        !!title &&
                        <Grid item xs={12}>
                            <SubTitleLight align={!!align ? align :  "left" }>{title} {!!required &&
                                <span className={this.classes.requiredSign}>*</span>}</SubTitleLight>
                        </Grid>
                    }
                    {
                        !!file &&
                        <Grid item xs={12}>
                            <List dense className="gallery" style={{marginTop: importer ? -20 : "unset"}}>
                                <ListItem>
                                    {
                                        file.type === "image" ?
                                            <ListItemAvatar>
                                                <Link href={getComplexFileUrl(file)} target="_blank">
                                                    <Avatar src={getComplexFileUrl(file,'_small')} />
                                                </Link>
                                            </ListItemAvatar>
                                            :
                                            file.type === "document" ?
                                                <ListItemAvatar>
                                                    <Avatar>
                                                        <PictureAsPdfRoundedIcon/>
                                                    </Avatar>
                                                </ListItemAvatar>
                                                :
                                                <ListItemAvatar>
                                                    <Avatar>
                                                        <OndemandVideoRoundedIcon/>
                                                    </Avatar>
                                                </ListItemAvatar>
                                    }

                                    <ListItemText primary={truncate(file.name,18)} secondary={Translate[file.type]} />
                                    {
                                        !disabled &&
                                        <ListItemSecondaryAction>
                                            <IconButton size="small" onClick={() => this.removeDataSheet()} aria-label={Translate.removeImage}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    }

                                </ListItem>
                            </List>
                        </Grid>
                    }
                    {
                        !disabled && !file &&
                        <Grid item xs={12}>
                            <Button
                                startIcon={!!icon ? icon : <AddBoxRoundedIcon />}
                                color={!!color ? color : "primary"}
                                variant="outlined"
                                size="small"
                                onClick={this.toggleOperation.bind(this)}
                            >
                                {!!label ? label : Translate.chooseFile}
                            </Button>
                        </Grid>

                    }

                </Grid>

                {
                    FileManagerPending ? <FileManagerDialog fileType={!!type ? type : 'all'}  selection cancleOperation={this.toggleOperation} setData={this.setData}/> : null
                }
            </React.Fragment>
        )

    }
}
export default withStyles(Styles)(SingleFileChooser);